<template>
  <div class="purchase-history-item">
    <router-link :to="`/purchase/history/detail/${item.id}`" tag="div">
      <div class="purchase-history-top">
        <p>计划单号：{{ item.plan_order_number }}</p>
        <p>
        {{item.state | getState}}
        </p>
      </div>
      <div class="purchase-history-middle">
        <div class="purchase-history-list" ref="orderList">
          <!-- <template v-if="item.goods_img"> -->
            <img
              class="purchase-history-list-img"
              v-for="(goods,index) in item.goods_img.slice(0, imgLimit)"
              :key="index"
              v-lazy="goods"
              ref="orderListImg"
            />
          <!-- </template> -->

          <i class="purchase-history-tips" > 共{{ item.goods_num }}件 </i>
        </div>
      </div>
    </router-link>
    <div class="purchase-history-bottom">
      <p>采购价：<span class="price">￥{{ item.total_price }}</span></p>
    </div>
  </div>
</template>

<script>
import { getStyle } from '~utils'
export default {
  name: 'purchase-history-item',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data () {
    return {
      imgLimit: 3
    }
  },
  computed: {

  },
  mounted () {
    this.gteImgLimit()
  },
  methods: {
    /**
     * 计算最多可展示多少张图片
     */
    gteImgLimit () {
      let marginRight = getStyle(this.$refs.orderListImg[0], 'marginRight')
      let oDomWidth = this.$refs.orderListImg[0].clientWidth + parseInt(marginRight)
      let clientWidth = this.$refs.orderList.clientWidth - oDomWidth
      this.imgLimit = Math.floor(clientWidth / oDomWidth)
    }

  },
  filters: {
    getState (value) {
      if (!value) return ''
      let item = value.toString()
      switch (item) {
        case '0':
          return '待审核'
        case '1':
          return '已审核'
        case '2':
          return '已拒绝'
        case '3':
          return '已取消'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.purchase-history {
  &-item {
    box-sizing: border-box;
    padding: 10px;
    border-left: 0;
    border-right: 0;
    box-shadow: $box-shadow-base;
    margin-bottom: 8px;
  }
  &-top {
    @include flex(row);
    padding-bottom: 12px;
    border-bottom: 1px solid $border-color-base;
    justify-content: space-between;
    font-size: 12px;
    color: $heading-color;
    font-weight: 700;
    .price {
      color: #EB1F1F;
      font-weight: 700;
    }
  }
  &-middle {
    padding: 15px 0;
    border-bottom: 1px solid $border-color-base;
    @include flex(row);
    align-items: center;
    .purchase-history-tips {
      width: 60px;
      height: 60px;
      background: #EEEEEE;
      color: #777777;
      font-size: 12px;
      float: right;

      @include center(row)
    }
  }
  &-bottom {
    padding-top: 10px;
    font-size: 11px;
  }
   &-list {
      width: 100%;
      height: 64px;
      &-img {
        width: 60px;
        height: 60px;
        padding: 1px;
        border: 1px solid $border-color-base;
        margin-right: 25px;
        }
    }
}
.price{
  color: #F92D6C;
  font-weight: bolder;
}
</style>
